var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"zoom","appear":""}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"prt-fab",attrs:{"aria-label":_vm.icon}},[_c('prt-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }